import { useMemo } from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { useAccountAlias } from "resources/account"
import { useQueryStringState } from "hooks/query-string"
import { Creators as DialogCreators } from "modules/dialog/model"
// [TODO] bring back here once old compare goes away
import AddOptions from "modules/comparison/components/add-options"
import { useSaveContextPreferences } from "hooks/preferences"
import { PORTFOLIO, SECURITY, BENCHMARK, INDEX, ETF, BASKET } from "../position-sets"

const EMPTY_ARRAY = []

function addPositionSet(updateQueryString, currentPositionSets, newPositionSet, savePositionSetsPreference) {
  const positionSets = [...currentPositionSets, newPositionSet]
  updateQueryString({ positionSets })
  savePositionSetsPreference(positionSets)
}

export default function CompareAddButton({ modelId, disabled }) {
  const accountAlias = useAccountAlias()
  const dispatch = useDispatch()
  const savePositionSetsPreference = useSaveContextPreferences("positionSets")
  const [{ positionSets: queryStringPositionSets = EMPTY_ARRAY }, updateQueryString] = useQueryStringState()

  const securityTypeAddActions = useMemo(() => ({
    benchmark: {
      mainAction: item => () => { addPositionSet(updateQueryString, queryStringPositionSets, { type: BENCHMARK, id: item.id }, savePositionSetsPreference) },
      noDispatch: true,
    },
    index: {
      mainAction: item => () => { addPositionSet(updateQueryString, queryStringPositionSets, { type: INDEX, id: item.id }, savePositionSetsPreference) },
      noDispatch: true,
    },
    security: {
      mainAction: item => () => {
        let newPositionSet
        switch (true) {
          case item.assetClass === "swap":
            newPositionSet = { type: BASKET, id: item.ticker }
            break
          case item.assetSubclass === "etf":
            newPositionSet = { type: ETF, id: item.internalId }
            break
          default:
            newPositionSet = { type: SECURITY, id: item.internalId }
        }

        addPositionSet(updateQueryString, queryStringPositionSets, newPositionSet, savePositionSetsPreference)
      },
      noDispatch: true,
    },
    portfolio: {
      mainAction: item => () => { addPositionSet(updateQueryString, queryStringPositionSets, { type: PORTFOLIO, id: item.alias }, savePositionSetsPreference) },
      noDispatch: true,
    },
  }), [updateQueryString, queryStringPositionSets, savePositionSetsPreference])

  return <div data-test-class="comparison-add-button">
    <AddOptions
      disabled={disabled}
      account={accountAlias}
      openDialog={(...args) => dispatch(DialogCreators.open(...args))}
      searchItemsActions={securityTypeAddActions}
      modelId={modelId}
      trackExperimentTypeSelection={() => {}}
    />
  </div>
}

CompareAddButton.propTypes = {
  modelId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}
